import React, { useState } from 'react';
import { Button, TextField, Container, Typography, Box, CircularProgress, IconButton, InputAdornment } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import { Link, useNavigate } from 'react-router-dom';
import Header from './Header';
import axios from 'axios';
import { toast } from "react-toastify";
import Cookies from 'js-cookie';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import ReCAPTCHA from "react-google-recaptcha";

function Login() {
  const [logindata, setLoginData] = useState({
    email: "",
    password: ""
  });
  const navigate = useNavigate();
  const [captchaToken, setCaptchaToken] = useState(null);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const apiUrl = process.env.REACT_APP_API_URL;
  const siteKey = process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY;

  const handleOnChange = (e) => {
    setLoginData({ ...logindata, [e.target.name]: e.target.value });
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleCaptchaChange = (token) => {
    // console.log("reCAPTCHA Token:", value);
    setCaptchaToken(token); // Store the CAPTCHA token
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { email, password } = logindata;

    // console.log("Login data:", { ...logindata, recaptcha_token: captchaToken });

    if (!email || !password) {
      // setError("Email and Password are required");
      toast.error("Email and Password are required");
    } else if (!captchaToken) {
      // setError("Please complete the reCAPTCHA verification.");
      toast.error("Please complete the reCAPTCHA verification.");
      return;
    } else {
      setIsLoading(true);
      try {
        // added from chatgpt
        const csrfToken = Cookies.get('csrftoken');
        const res = await axios.post(`${apiUrl}/api/v1/auth/login/`, 
          // {logindata, recaptcha_token: captchaToken,},
          {
            email,
            password,
            // captcha_token: captchaToken, // Correct field name
            recaptcha_token: captchaToken,
          },
          { withCredentials: true,
            headers: { 'X-CSRFToken': csrfToken }
            // // added from chatgpt
            // headers: {
            //   'X-CSRFToken': csrfToken, // Send the CSRF token
            // },
          }
        );
        setIsLoading(false);

        Cookies.set("user", JSON.stringify({ email: res.data.email, names: res.data.full_name, user_id: res.data.user_id }), { secure: true, sameSite: 'None' });
        // Cookies.set("access", res.data.access_token, { secure: true, sameSite: 'None' });
        // Cookies.set("refresh", res.data.refresh_token, { secure: true, sameSite: 'None' });
        // Cookies.set("refresh", res.data.refresh_token, { secure: true, sameSite: 'None' });

        navigate("/");

        const successMessage = res.data.message || "Login successful";
        toast.success(successMessage);

      } catch (err) {
        setIsLoading(false);
        console.error("Login error:", err);

        let errorMessage = "Login failed. Please try again.";
        if (err.response && err.response.data) {
          errorMessage = err.response.data.detail || "Login failed. Please check your credentials.";
        }

        toast.error(errorMessage);
      }
    }
  };

  if (isLoading) {
    return (
      <div style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <CircularProgress />
      </div>
    );
  }

  return (
    <>
      <Header />
      <Box display="flex" justifyContent="center" alignItems="center" mt={3} mb={2}>
        <HomeIcon fontSize="large" />
        <Typography 
          variant="h4" 
          ml={1}
          sx={{
            fontSize: { xs: '1.5rem', sm: '2rem' }, // Adjust font size for mobile screens
          }}
        >
          Login
        </Typography>
      </Box>
      <Container 
        maxWidth="sm"
        sx={{
          p: { xs: 2, sm: 4 }, // Adjust padding based on screen size
          boxShadow: 2,
          borderRadius: 2,
          backgroundColor: 'white'
        }}
      >
        <form onSubmit={handleSubmit}>
          <TextField
            label="Email"
            name="email"
            value={logindata.email}
            onChange={handleOnChange}
            variant="outlined"
            margin="normal"
            fullWidth
            required
            InputLabelProps={{
              sx: { fontSize: { xs: '0.8rem', sm: '1rem' } } // Adjust label font size
            }}
          />
          <TextField
            label="Password"
            name="password"
            value={logindata.password}
            onChange={handleOnChange}
            type={showPassword ? "text" : "password"}
            variant="outlined"
            margin="normal"
            fullWidth
            required
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={togglePasswordVisibility}>
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              )
            }}
            InputLabelProps={{
              sx: { fontSize: { xs: '0.8rem', sm: '1rem' } } // Adjust label font size
            }}
          />
          <Box display="flex" justifyContent="center" mt={2}>
            <ReCAPTCHA
              // sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
              sitekey={siteKey}
              // onChange={(token) => setCaptchaToken(token)}
              onChange={handleCaptchaChange}
            />
          </Box>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            sx={{
              mt: 2,
              py: { xs: 1, sm: 1.5 }, // Adjust padding for button
              fontSize: { xs: '0.875rem', sm: '1rem' } // Adjust font size for button text
            }}
          >
            Login
          </Button>
        </form>
        <Box mt={2} display="flex" justifyContent="space-between" sx={{ fontSize: { xs: '0.8rem', sm: '0.9rem' } }}>
          <Link to="/signup">Don't have an account? Sign up</Link>
          <Link to="/forgot-password">Forgot Password?</Link>
        </Box>
      </Container>
    </>
  );
}

export default Login;

// worked well just that i nnede the layout to align with the signup page
// import React, { useState } from 'react';
// import { Button, TextField, Container, Typography, Box, CircularProgress, IconButton, InputAdornment, useMediaQuery } from '@mui/material'; 
// import HomeIcon from '@mui/icons-material/Home';
// import { Link, useNavigate } from 'react-router-dom';
// import Header from './Header';
// import axios from 'axios';
// import { toast } from "react-toastify";
// import Cookies from 'js-cookie';
// import { Visibility, VisibilityOff } from '@mui/icons-material';
// import { useTheme } from '@mui/material/styles';

// function Login() {
//   const [logindata, setLoginData] = useState({
//     email: "",
//     password: ""
//   });
//   const navigate = useNavigate();
//   const [error, setError] = useState("");
//   const [isLoading, setIsLoading] = useState(false);
//   const [showPassword, setShowPassword] = useState(false);

//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // Check if screen size is mobile

//   const handleOnChange = (e) => {
//     setLoginData({ ...logindata, [e.target.name]: e.target.value });
//   };

//   const togglePasswordVisibility = () => {
//     setShowPassword(!showPassword);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const { email, password } = logindata;

//     if (!email || !password) {
//       setError("Email and Password are required");
//     } else {
//       setIsLoading(true);

//       try {
//         const res = await axios.post("http://localhost:8000/api/v1/auth/login/", logindata, { withCredentials: true });
//         setIsLoading(false);

//         Cookies.set("user", JSON.stringify({ email: res.data.email, names: res.data.full_name, user_id: res.data.user_id }), { secure: true, sameSite: 'Strict' });

//         navigate("/");

//         const successMessage = res.data.message || "Login successful";
//         toast.success(successMessage);

//       } catch (err) {
//         setIsLoading(false);
//         console.error("Login error:", err);

//         let errorMessage = "Login failed. Please try again.";
//         if (err.response && err.response.data) {
//           errorMessage = err.response.data.detail || "Login failed. Please check your credentials.";
//         }

//         toast.error(errorMessage);
//       }
//     }
//   };

//   if (isLoading) {
//     return (
//       <div style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
//         <CircularProgress />
//       </div>
//     );
//   }

//   return (
//     <>
//       <Header />
//       <Box display="flex" justifyContent="center" alignItems="center" mt={isMobile ? 2 : 3} mb={isMobile ? 1 : 2}>
//         <HomeIcon fontSize="large" />
//         <Typography variant={isMobile ? "h5" : "h4"} ml={1}>
//           Login
//         </Typography>
//       </Box>
//       <Container maxWidth="sm" sx={{ px: isMobile ? 2 : 0 }}>
//         <form onSubmit={handleSubmit}>
//           <TextField
//             label="Email"
//             name="email"
//             value={logindata.email}
//             onChange={handleOnChange}
//             variant="outlined"
//             margin="normal"
//             fullWidth
//             required
//           />
//           <TextField
//             label="Password"
//             name="password"
//             value={logindata.password}
//             onChange={handleOnChange}
//             type={showPassword ? "text" : "password"}
//             variant="outlined"
//             margin="normal"
//             fullWidth
//             required
//             InputProps={{
//               endAdornment: (
//                 <InputAdornment position="end">
//                   <IconButton onClick={togglePasswordVisibility}>
//                     {showPassword ? <VisibilityOff /> : <Visibility />}
//                   </IconButton>
//                 </InputAdornment>
//               )
//             }}
//           />
//           <Button type="submit" variant="contained" color="primary" fullWidth sx={{ mt: 2 }}>
//             Login
//           </Button>
//         </form>
//         <Box mt={2} display="flex" flexDirection={isMobile ? "column" : "row"} alignItems="center" justifyContent="space-between">
//           <Link to="/signup" style={{ marginBottom: isMobile ? 8 : 0 }}>Don't have an account? Sign up</Link>
//           <Link to="/forgot-password">Forgot Password?</Link>
//         </Box>
//       </Container>
//     </>
//   );
// }

// export default Login;

// worked well just that i added mobile responsiveness to the code above
// import React, { useState } from 'react';
// import { Button, TextField, Container, Typography, Box, CircularProgress, IconButton, InputAdornment } from '@mui/material'; 
// import HomeIcon from '@mui/icons-material/Home';
// import { Link, useNavigate } from 'react-router-dom';
// import Header from './Header';
// import axios from 'axios';
// import { toast } from "react-toastify";
// import Cookies from 'js-cookie';
// import { Visibility, VisibilityOff } from '@mui/icons-material';

// function Login() {
//   const [logindata, setLoginData] = useState({
//     email: "",
//     password: ""
//   });
//   const navigate = useNavigate();
//   const [error, setError] = useState("");
//   const [isLoading, setIsLoading] = useState(false);
//   const [showPassword, setShowPassword] = useState(false); // State for password visibility

//   const handleOnChange = (e) => {
//     setLoginData({ ...logindata, [e.target.name]: e.target.value });
//   };

//   const togglePasswordVisibility = () => {
//     setShowPassword(!showPassword);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const { email, password } = logindata;

//     if (!email || !password) {
//       setError("Email and Password are required");
//     } else {
//       setIsLoading(true);

//       try {
//         const res = await axios.post("http://localhost:8000/api/v1/auth/login/", logindata, { withCredentials: true });
//         setIsLoading(false);

//         // Set cookies with user data and tokens
//         Cookies.set("user", JSON.stringify({ email: res.data.email, names: res.data.full_name, user_id: res.data.user_id }), { secure: true, sameSite: 'Strict' });

//         navigate("/");

//         const successMessage = res.data.message || "Login successful";
//         toast.success(successMessage);

//       } catch (err) {
//         setIsLoading(false);
//         console.error("Login error:", err);

//         let errorMessage = "Login failed. Please try again.";
//         if (err.response && err.response.data) {
//           errorMessage = err.response.data.detail || "Login failed. Please check your credentials.";
//         }

//         toast.error(errorMessage);
//       }
//     }
//   };

//   if (isLoading) {
//     return (
//       <div style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
//         <CircularProgress />
//       </div>
//     );
//   }

//   return (
//     <>
//       <Header />
//       <Box display="flex" justifyContent="center" alignItems="center" mt={3} mb={2}>
//         <HomeIcon fontSize="large" />
//         <Typography variant="h4" ml={1}>
//           Login
//         </Typography>
//       </Box>
//       <Container maxWidth="sm">
//         <form onSubmit={handleSubmit}>
//           <TextField
//             label="Email"
//             name="email"
//             value={logindata.email}
//             onChange={handleOnChange}
//             variant="outlined"
//             margin="normal"
//             fullWidth
//             required
//           />
//           <TextField
//             label="Password"
//             name="password"
//             value={logindata.password}
//             onChange={handleOnChange}
//             type={showPassword ? "text" : "password"} // Conditionally set input type
//             variant="outlined"
//             margin="normal"
//             fullWidth
//             required
//             InputProps={{
//               endAdornment: (
//                 <InputAdornment position="end">
//                   <IconButton onClick={togglePasswordVisibility}>
//                     {showPassword ? <VisibilityOff /> : <Visibility />}
//                   </IconButton>
//                 </InputAdornment>
//               )
//             }}
//           />
//           <Button type="submit" variant="contained" color="primary" fullWidth>
//             Login
//           </Button>
//         </form>
//         <Box mt={2} display="flex" justifyContent="space-between">
//           <Link to="/signup">Don't have an account? Sign up</Link>
//           <Link to="/forgot-password">Forgot Password?</Link>
//         </Box>
//       </Container>
//     </>
//   );
// }

// export default Login;

// // worked well just that i added password visibilty to the code above
// import React, { useState } from 'react';
// import { Button, TextField, Container, Typography, Box, CircularProgress } from '@mui/material'; 
// import HomeIcon from '@mui/icons-material/Home';
// import { Link, useNavigate } from 'react-router-dom';
// import Header from './Header';
// import axios from 'axios';
// import { toast } from "react-toastify";
// import Cookies from 'js-cookie';

// function Login() {
//   const [logindata, setLoginData] = useState({
//     email: "",
//     password: ""
//   });
  
//   const navigate = useNavigate();
//   const [error, setError] = useState("");
//   const [isLoading, setIsLoading] = useState(false);

//   const handleOnChange = (e) => {
//     setLoginData({ ...logindata, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const { email, password } = logindata;
  
//     if (!email || !password) {
//       setError("Email and Password are required");
//     } else {
//       setIsLoading(true);
//       // console.log("Sending login request:", logindata);
  
//       try {
//         const res = await axios.post("http://localhost:8000/api/v1/auth/login/", logindata, { withCredentials: true });
//         // console.log("Login response:", res.data);
  
//         setIsLoading(false);
  
//         // Set cookies with user data and tokens
//         Cookies.set("user", JSON.stringify({ email: res.data.email, names: res.data.full_name, user_id: res.data.user_id }), { secure: true, sameSite: 'Strict' });
//         // Cookies.set("user_id", JSON.stringify({ user_id: res.data.user_id }), { secure: true, sameSite: 'Strict' });
//         // Cookies.set("access", res.data.access_token, { secure: true, sameSite: 'Strict' });
//         // Cookies.set("refresh", res.data.refresh_token, { secure: true, sameSite: 'Strict' });
  
//         // Redirect after successful login
//         navigate("/");
  
//         // Display backend success message (assuming the backend sends a 'message' field)
//         const successMessage = res.data.message || "Login successful";
//         toast.success(successMessage);
  
//       } catch (err) {
//         setIsLoading(false);
//         console.error("Login error:", err);
  
//         // Extract and show error message from backend
//         let errorMessage = "Login failed. Please try again.";
//         if (err.response && err.response.data) {
//           // Check if there's a specific error message in the response
//           errorMessage = err.response.data.detail || "Login failed. Please check your credentials.";
//         }
  
//         toast.error(errorMessage);
//       }
//     }
//   };   

//   if (isLoading) {
//     return (
//       <div style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
//         <CircularProgress />
//       </div>
//     );
//   }

//   return (
//     <>
//       <Header />
//       <Box display="flex" justifyContent="center" alignItems="center" mt={3} mb={2}>
//         <HomeIcon fontSize="large" />
//         <Typography variant="h4" ml={1}>
//           Login
//         </Typography>
//       </Box>
//       <Container maxWidth="sm">
//         <form onSubmit={handleSubmit}>
//           <TextField
//             label="Email"
//             name="email"
//             value={logindata.email}
//             onChange={handleOnChange}
//             variant="outlined"
//             margin="normal"
//             fullWidth
//             required
//           />
//           <TextField
//             label="Password"
//             name="password"
//             value={logindata.password}
//             onChange={handleOnChange}
//             type="password"
//             variant="outlined"
//             margin="normal"
//             fullWidth
//             required
//           />
//           <Button type="submit" variant="contained" color="primary" fullWidth>
//             Login
//           </Button>
//         </form>
//         <Box mt={2} display="flex" justifyContent="space-between">
//           <Link to="/signup">Don't have an account? Sign up</Link>
//           <Link to="/forgot-password">Forgot Password?</Link>
//         </Box>
//       </Container>
//     </>
//   );
// }

// export default Login;

